import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า BUN โดยใช้ค่าปกติจาก medium.json
 * @param {string|number} value - ค่า BUN
 * @param {number} age - อายุ (ปี)
 * @param {string|number} gender - เพศ (male/female หรือ 1/0)
 * @returns {Promise<object>} - {title, color, caption, suggest}
 */
export default async (value, age = 25, gender = 'M') => {
  return await checkWithMediumJson(value, 'BUN, Urea', gender, age, 'BUN');
};
